export default __webpack_public_path__ + "aec2ba34cb44427b634f59cecf8e992f.gif";